import axios, { AxiosResponse } from "axios";

const axiosFileInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

axiosFileInstance.interceptors.request.use(
  (config) => {
    const authToken =
      typeof window !== "undefined" && localStorage.getItem("authToken");
    if (authToken) {
      config.headers["Authorization"] = `Bearer ${authToken}`;
      config.headers["Accept"] = "application/json";
      config.headers["Content-Type"] = "application/json";
      config.headers["Content-Type"] = "multipart/form-data";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const ResponseInterceptor = (response) => {
  return response;
};

axiosFileInstance.interceptors.response.use(ResponseInterceptor, (error) => {
  if (error.response.status === 401 || error.response.status === 403) {
    localStorage.removeItem("authToken");
    window && window.open("/login", "_self");
  } else {
    return Promise.reject(error);
  }
});

export default axiosFileInstance;
